import { authFetch } from '../AuthFetch';
import { createAction } from 'redux-actions';

// export const forwardToSetMaintenanceTargetCard = createAction('SET_MAINTENANCE_TARGET_CARD');
export const forwardToSetMaintenanceTargetCard = (cardId) => (
  (dispatch) => {
    dispatch({
      type: 'SET_MAINTENANCE_TARGET_CARD',
      payload: cardId
    });

    dispatch({
      type: 'CLEAN_ALERT',
      payload: null
    });
  }
);

//id :case pk
export const forwardToReloadMaintenanceCase = (id) => (
  (dispatch) => {
    let url = '/maintenance/mcases/' + id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'RELOAD_MAINTENANCE_CASE',
        payload: json
      });
    });
  }
);

//id :case pk
export const forwardToFindMaintenanceCards = (cardRequest) => (
  (dispatch) => {
    let id = cardRequest.casePk;
    let url = '/maintenance/mcases/i' + id + '/cards/status';
    authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_CARDS_BY_FK',
        payload: json
      });
    });
  }
);

export const forwardToEvaluateMaintenanceStatistic = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/statistic';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'EVALUATE_MAINTENANCE_STATISTIC',
        payload: json
      });
    });
  }
);

export const forwardToSetMaintenanceCaseChecking = (id) => (
  (dispatch) => {
    let request = { casePk: id, status: 'CHECKING' };
    let url = '/maintenance/mcases/' + id + '/status';
    authFetch('POST', url, JSON.stringify(request), null);
  }
);

export const forwardToSetMaintenanceCaseModified = (id) => (
  (dispatch) => {
    let request = { casePk: id, status: 'MODIFIED' };
    let url = '/maintenance/mcases/' + id + '/status';
    authFetch('POST', url, JSON.stringify(request), null);
  }
);

export const forwardToCleanMcardsAlert = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'CLEAN_MAINTENANCE_CARDS_ALERT',
        payload: null,
      }
    )
  }
);

export const forwardToResetCheckFileLink = (casePk) => (
  (dispatch) => {
    dispatch(
      {
        type: 'RESET_CHECK_FILE_LINK',
        payload: casePk,
      }
    )
  }
);

export const forwardToSetFilterString = (filterString) => (
  (dispatch) => {
    dispatch(
      {
        type: 'SET_CARDS_FILTER_STRING',
        payload: filterString,
      }
    )
  }
);

export const forwardToResortingMCardsByCriteria = (cards, filterString) => {

  if (filterString == undefined || filterString === '') {
    return;
  }

  let match = [];
  let dis = [];

  cards.map((card, index) => {
    if (card.code.toLowerCase().includes(filterString.toLowerCase())) {
      match.push(card);
    } else {
      dis.push(card);
    }
  });

  let ret = (dispatch) => {
    dispatch(
      {
        type: 'SET_MAINTENANCE_CARDS',
        payload: match.concat(dis),
      }
    )
  }
  return ret;
};

export const forwardToSortMaintenanceCards = (cards, order) => {
  let asc = order.get('asc') == undefined ? true : order.get('asc');
  let by = order.get('by');
  let clone = [];
  cards.map((item, index) => {
    clone.push(item);
  });

  switch (by) {
    case "code":
      clone.sort((a, b) => {
        let comparison = asc ? (a.code < b.code) : (a.code > b.code);
        return comparison ? 1 : -1;
      });
      break;
    case "status":
      clone.sort((a, b) => {
        let comparison = asc ? (a.status < b.status) : (a.status > b.status);
        return comparison ? 1 : -1;
      });
      break;
    case "owner":
      clone.sort((a, b) => {
        let comparison = asc ? (a.owner < b.owner) : (a.owner > b.owner);
        return comparison ? 1 : -1;
      });
      break;
    case "unit":
      clone.sort((a, b) => {
        let comparison = asc ? (a.unit < b.unit) : (a.unit > b.unit);
        return comparison ? 1 : -1;
      });
      break;
  }

  let ret = (dispatch) => {
    dispatch(
      {
        type: 'SORT_CARDS_BY_FIELD',
        payload: { cards: clone, order: order },
      }
    )
  }

  return ret;
};

export const forwardToFindPhotosByCard = (cardId) => (
  (dispatch) => {
    let url = "/maintenance/photos/cards/i" + cardId + "/find";
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_PHOTO_LIST',
        payload: json,
      });
    });
  }
);

export const changePhotoListPreviousPage = createAction('CHANGE_PHOTO_LIST_PREVIOUS_PAGE');


// WEBPACK FOOTER //
// ./src/actions/maintenanceCardsActions.js